//global.BASE_URL = 'http://localhost:58112';
global.BASE_URL = 'http://api.xuelintianxia.com';